// ===============================================
// 🔐 CONTEXTO DE AUTENTICAÇÃO - INHOLDING
// ===============================================
// Arquivo: src/context/AuthContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Verificar se há token salvo ao inicializar
  useEffect(() => {
    const initAuth = async () => {
      try {
        
        const token = localStorage.getItem('auth_token');
        const userData = localStorage.getItem('user_data');
        
        if (token && userData) {
          
          // Verificar se token ainda é válido
          const response = await api.get('/auth/verify');
          
          if (response.data.success) {
            const userInfo = JSON.parse(userData);
            setUser(userInfo);
            setIsAuthenticated(true);
          } else {
            clearAuthData();
          }
        } else {
        }
      } catch (error) {
        console.error('❌ Erro ao verificar autenticação:', error);
        clearAuthData();
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const clearAuthData = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    setUser(null);
    setIsAuthenticated(false);
  };

  const login = async (usuario, senha) => {
    try {
      setLoading(true);
      
      const response = await api.post('/auth/login', {
        usuario,
        senha
      });

      if (response.data.success) {
        const { token, user: userData } = response.data;
        
        
        // Salvar dados no localStorage
        localStorage.setItem('auth_token', token);
        localStorage.setItem('user_data', JSON.stringify(userData));
        
        setUser(userData);
        setIsAuthenticated(true);
        
        return { 
          success: true, 
          message: 'Login realizado com sucesso!'
        };
      } else {
        return { 
          success: false, 
          message: response.data.message || 'Erro ao fazer login' 
        };
      }
    } catch (error) {
      console.error('❌ Erro no login:', error);
      
      if (error.response?.status === 401) {
        return { 
          success: false, 
          message: 'Usuário ou senha incorretos' 
        };
      } else if (error.response?.status === 429) {
        return { 
          success: false, 
          message: 'Muitas tentativas. Tente novamente em alguns minutos.' 
        };
      } else if (error.code === 'ERR_NETWORK' || !error.response) {
        return { 
          success: false, 
          message: 'Erro de conexão. Verifique se o servidor está rodando.' 
        };
      } else {
        return { 
          success: false, 
          message: error.response?.data?.message || 'Erro de conexão. Verifique sua internet.' 
        };
      }
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      
      // Notificar o servidor sobre o logout
      await api.post('/auth/logout');
    } catch (error) {
      console.error('❌ Erro ao fazer logout no servidor:', error);
    } finally {
      // Limpar dados locais sempre
      clearAuthData();
    }
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    logout
  };


  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
